module.exports = __webpack_public_path__ + "static/media/project6.a3dc0976.jpg";